import { ExerciseV2Wizard } from '@/features/exercise-v2-wizard';

export function TutorExercisesNewV2Page() {
  return <ExerciseV2Wizard />;
}
